import React from 'react';
import { FileText, Download, Trash2 } from 'lucide-react';

export default function DocumentList({ documents, onDeleteDocument }) {
    const handleDelete = (documentId) => {
        if (window.confirm('Are you sure you want to delete this document?')) {
            onDeleteDocument(documentId);
        }
    };

    return (
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
            <div className="grid grid-cols-1 divide-y divide-gray-100">
                {documents.map((doc) => (
                    <div key={doc._id} className="p-4 hover:bg-gray-50/50">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
                                    <FileText className="w-5 h-5 text-blue-600" />
                                </div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-900">{doc.documentTitle}</h3>
                                    <p className="text-sm text-gray-500">
                                        Uploaded by {doc.uploadedBy.name} • {new Date(doc.createdAt).toLocaleString()}
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                {/* Download button linking to the document's download URL */}
                                <a href={doc.downloadUrl} download className="p-2 text-gray-400 hover:text-blue-600">
                                    <Download className="w-4 h-4" />
                                </a>
                                {/* <button
                                    onClick={() => handleDelete(doc._id)}
                                    className="p-2 text-gray-400 hover:text-red-600"
                                >
                                    <Trash2 className="w-4 h-4" />
                                </button> */}
                            </div>
                        </div>
                        <div className="mt-2 flex items-center gap-4">
                            <span className="text-xs text-gray-500">{doc.size}</span>
                            <span className="text-xs text-gray-500">Accessible to: {doc.accessibleBy.join(', ')}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
